<template>
    <div>
        <ModelAutoComplete
            :label="label"
            :placeholder="label"
            :value="value"
            :vizKeyPath="[['value']]"
            :items="regions"
            :item-selected="value"
            @debounce-end="getAutocompleteAddress"
            @selected="getFullAddress"
            :required="true"
        />
    </div>
</template>

<script>
import ModelAutoComplete from "@/components/UI/models/ModelAutoComplete.vue";
import {mapActions} from "vuex";

export default {
    name: "ModelAddress",
    components: {ModelAutoComplete},
    props: {
        label: String,
        value: Object,
    },
    data: () => {
        return {
            regions: [],
        };
    },
    methods: {
        ...mapActions('dadata', ['getAddress']),
        async getAutocompleteAddress(inputObj) {
            if (inputObj.value) {
                this.regions = await this.getAddress({query: inputObj.value, url: 'search'});
            }
        },
        async getFullAddress(item) {
            const data = await this.getAddress({query: item.value, url: 'clean'});
            if (data.length > 0) {
                this.$emit('input', data[0]);
            }
        },
    },
};
</script>

<style scoped>

</style>